import { render, staticRenderFns } from "./RadarDot.vue?vue&type=template&id=675e916b&scoped=true&"
import script from "./RadarDot.vue?vue&type=script&lang=js&"
export * from "./RadarDot.vue?vue&type=script&lang=js&"
import style0 from "./RadarDot.vue?vue&type=style&index=0&id=675e916b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675e916b",
  null
  
)

export default component.exports